import styled from "styled-components";

export const ContainerButtons = styled.div`
    flex: auto;
    background: #F7F7F7;
    border-radius: 10px;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1rem;

    button{
        width: 98%;
        max-width: 500px;
    }
`

export const Container = styled.div`
    flex: auto;
    overflow-y: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 2px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;
`